import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import get from 'lodash/get';
import selector from '@store/comparison/sharing/selectors';
import * as compareSharingActions from '@store/comparison/sharing/actions';
import sharing from '../common/sharing';
import CustomDashboard from '../custom-dashboard/CustomDashboard';

const compareSharingPageSelector = createSelector(
  selector,
  store => ({
    isFetching: get(store, 'isFetching', false),
  }),
);

const compareSharing = connect(
  compareSharingPageSelector,
  {
    init: compareSharingActions.initRequest,
    getSharing: compareSharingActions.getSharing,
  },
)(sharing()(CustomDashboard));

export default compareSharing;
